import React from 'react';
import { CheckCircle, XCircle } from 'react-feather';

import { Card } from 'styles/Commons';
import { ButtonLink } from 'styles/Form';
import * as S from './styles';

interface TransferAcceptResponseProps {
	error: boolean;
	message: string;
}

const TransferAcceptResponse = ({ error, message }: TransferAcceptResponseProps) => (
	<S.Wrapper>
		<Card padding="2.5rem 2rem">
			<S.Content>
				<S.IconBadge error={error}>
					{error ? <XCircle size={36} /> : <CheckCircle size={36} />}
				</S.IconBadge>

				<S.Message>{message}</S.Message>

				<ButtonLink to="/meus-ingressos">Ir para Meus Ingressos</ButtonLink>
			</S.Content>
		</Card>
	</S.Wrapper>
);

export default TransferAcceptResponse;
